import React, {useEffect, useState} from 'react'
import '../assets/css/Panel.css'
import Navbar from "../components/Navbar";
import {useNavigate} from "react-router-dom";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import {useDisclosure} from "@chakra-ui/react";
import Loader from "../components/Loader";
import {BundleModal, DeleteBundleModal} from "../components/BundleModal";
import AdminBundleCard from "../components/adminBundleCard";
import FileModal from "../components/FileModal";
import TableToolbar from "../components/TableToolbar";
import Pagination from "../components/Pagination";

function Bundles() {
    const navigate = useNavigate();
    const [bundles, setExams] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [refresh, setRefresh] = useState(true);
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {isOpen: isOpenDelete, onOpen: onOpenDelete, onClose: onCloseDelete } = useDisclosure()
    const {isOpen: isOpenFiles, onOpen: onOpenFiles, onClose: onCloseFiles } = useDisclosure()
    const [selectedExam, setSelectedExam] = useState(null);
    const [loading,setLoading] = useState(false);
    const openModal = (bundle) => {
        setSelectedExam(bundle);
        onOpen();
    };
    const openDeleteModal = (bundle) => {
        setSelectedExam(bundle);
        onOpenDelete();
    };
    const openFilesModal = (bundle) => {
        setSelectedExam(bundle);
        onOpenFiles();
    };
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/bundles')
                setExams(response.data.data);
                setCurrentPage(response.data.current_page)
                setLastPage(response.data.last_page)

            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
                setRefresh(false);
            }
        }
        if (refresh)
            fetchData();
    }, [currentPage, refresh]);

    if (loading) return <Loader />
    if (error) return <ErrorPage error={error}/>;
    return (
        <>
            <div className="d-flex flex-column h-100">
                <Navbar/>
                <div className="px-3 pt-3">
                    <TableToolbar title="فایل ها" count={bundles.length}/>
                </div>
                <div className="cards-container row pt-3 justify-content-center">
                    <AdminBundleCard NewExamTitle={'مجموعه فایل جدید'} onClickCard={() => {
                        openModal(null)
                    }} newExam={true}/>
                    {bundles.map((bundle) => (
                        <AdminBundleCard navigator={navigate} bundle={bundle} onClickCard={() => openModal(bundle)}
                                       onDeleteClick={() => {
                                           openDeleteModal(bundle)
                                       }} onFilesClick={() => {
                            openFilesModal(bundle)
                        }}/>
                    ))}
                </div>
                <div className="py-2">
                    <Pagination currentPage={currentPage} lastPage={lastPage} onChange={setCurrentPage}/>
                </div>
            </div>
            <BundleModal isOpen={isOpen} onClose={onClose} setRefresh={setRefresh} bundle={selectedExam}/>
            <DeleteBundleModal isOpen={isOpenDelete} onCloseDelete={onCloseDelete} setRefresh={setRefresh}
                             bundle={selectedExam}/>
            <FileModal onClose={onCloseFiles} isOpen={isOpenFiles} bundle={selectedExam}/>
        </>
    );
}

export default Bundles;
